import styled from 'styled-components';

interface IMenuWrapper {
  hide: boolean;
}

export const MenuWrapper = styled.div<IMenuWrapper>`
  display: ${props => (props.hide ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 80px;
  height: 100vh;
  width: 100%;
`;

export const Background = styled.div`
  display: inline-block;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 20px;
  margin-bottom: 25px;
  @media (max-width: 600px) {
    & * {
      width: 100%;
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;

export const Menu = styled.div`
  background: #fff;

  width: 100%;
  min-height: 100vh;
  padding: 30px;
`;

export const MenuTop = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  row-gap: 20px;
`;

export const BackWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #1c1b3a;
  font-weight: 600;
  font-size: 2.5rem;
`;

export const BackAnchor = styled.span`
  display: flex;
  align-items: center;
  line-height: 1;
  margin-right: 16px;
`;

export const ArrowBack = styled.img`
  height: 20px;
  width: auto;
`;

export const PageTitle = styled.h4`
  margin: 0;
`;
